import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsScheduleInterviewByWorkplace() {
  return useCbhFlag(CbhFeatureFlag.SCHEDULE_INTERVIEW_BY_WORKPLACE, {
    defaultValue: false,
  });
}
